import { useDispatch, useSelector } from 'react-redux';
import { Typography } from '@mui/material';
import { LinkContainer, PrimaryLinkContainer } from './styles';
import Link from '../Link/Link';
import { useEffect, useState } from 'react';
import api from '../../api';
import { setPrimaryLinksData } from '../../redux/modelDataSlice';
import { recordEvent } from '../../utils/analytics/local';
import { ReactComponent as ProduckPageIcon } from '../../images/icons/productPageIcon.svg';
import { ReactComponent as DatasheetIcon } from '../../images/icons/datasheetIcon.svg';
import { sendAdobeEvent } from '../../utils/analytics/adobe';
import { APP_NAME } from '../../utils/constants/general';

const PrimaryLinks = () => {
	const primaryLinksDefinition = useSelector(state => state.designDefinition.partDefinition.primaryLinks);
	const defaultMappingName = useSelector(state => state.designDefinition.partDefinition.defaultMappingName);
	const wpn = useSelector(state => state.designDefinition.partDefinition.wpn);
	const [loading, setLoading] = useState(true);
	const dispatch = useDispatch();
	const primaryLinksData = useSelector(state => state.modelData.primaryLinksData);

	const ICONS = {
		productPageLink: ProduckPageIcon,
		datasheetLink: DatasheetIcon
	};

	useEffect(() => {
		const createLinksDataRequest = () => {
			const linksParameters = primaryLinksDefinition.map(column => column.id);
			return {
				opn: defaultMappingName,
				parameters: linksParameters
			};
		};

		const fetchData = async () => {
			try {
				setLoading(true);

				const fetchedData = await api.gainParametersForLinks(createLinksDataRequest());

				dispatch(setPrimaryLinksData(fetchedData));

				setLoading(false);
			} catch (err) {
				console.error(err);
			}
		};
		fetchData();
	}, [dispatch, defaultMappingName, primaryLinksDefinition]);

	const handleEventRecord = link => {
		recordEvent(link.id, JSON.stringify(defaultMappingName));
		if (link.id === 'datasheetLink')
			sendAdobeEvent(
				'Data Sheet',
				window.location.href,
				APP_NAME + ' | ' + defaultMappingName,
				primaryLinksData[link.id],
				null,
				wpn
			);
	};

	return (
		<>
			{!loading && (
				<PrimaryLinkContainer>
					<div>
						{primaryLinksDefinition.map((link, index) => {
							if (!primaryLinksData[link.id]) return null;

							return (
								<Typography variant="subtitle2" component="h6" sx={{ mb: 2 }} key={index}>
									{link.description}:
								</Typography>
							);
						})}
					</div>
					<div>
						{primaryLinksDefinition.map((link, index) => {
							if (!primaryLinksData[link.id]) return null;

							const IconComponent = ICONS[link.id];

							return (
								<LinkContainer key={index}>
									<Link
										href={primaryLinksData[link.id]}
										target="_blank"
										onClick={() => {
											handleEventRecord(link, primaryLinksData[link.id]);
										}}>
										<IconComponent alt="DocumentIcon" height={32} width={32} />
									</Link>
									<Link
										href={primaryLinksData[link.id]}
										target="_blank"
										onClick={() => {
											handleEventRecord(link, primaryLinksData[link.id]);
										}}>
										<Typography variant="subtitle2" sx={{ ml: '5px', mb: '4px' }}>
											{link.heading}
										</Typography>
									</Link>
								</LinkContainer>
							);
						})}
					</div>
				</PrimaryLinkContainer>
			)}
		</>
	);
};

export default PrimaryLinks;
